import { useGetList } from 'react-admin';

export interface EmployeeSummary {
  id: string;
  firstName: string;
  lastName: string;
  employeeNumber: string;
  department: string;
  jobTitle: string;
  email: string;
}

export function useEmployeeMap(): Map<string, EmployeeSummary> {
  const { data } = useGetList('employees', { pagination: { page: 1, perPage: 1000 } });

  const map = new Map<string, EmployeeSummary>();
  if (data) {
    for (const emp of data) {
      const le = emp.legalEntity as Record<string, string> | undefined;
      map.set(emp.id, {
        id: emp.id,
        firstName: le?.firstName ?? emp.firstName ?? '',
        lastName: le?.lastName ?? emp.lastName ?? '',
        employeeNumber: emp.employeeNumber ?? '',
        department: emp.organisationalHierarchy?.department ?? '',
        jobTitle: emp.seniority?.jobTitle ?? '',
        email: le?.email ?? emp.email ?? '',
      });
    }
  }
  return map;
}

export function getEmployeeName(employeeMap: Map<string, EmployeeSummary>, employeeId: string | undefined): string {
  if (!employeeId) return '—';
  const emp = employeeMap.get(employeeId);
  if (!emp) return '—';
  return `${emp.firstName} ${emp.lastName}`.trim() || '—';
}

export function getEmployeeField<T extends keyof EmployeeSummary>(
  employeeMap: Map<string, EmployeeSummary>,
  employeeId: string | undefined,
  field: T,
  fallback: string = '—'
): string {
  if (!employeeId) return fallback;
  const emp = employeeMap.get(employeeId);
  if (!emp) return fallback;
  return (emp[field] as string) || fallback;
}
